import { styled } from "@iventis/styles";
import React from "react";
import CustomSwitchComponent from "@iventis/components/src/switch-component";
import { useSubjectContext } from "../../state/subjects-context";

export function CadPositionLockButton() {
    const { allowCadMovePosition$ } = useSubjectContext();

    const [allowMovement, setAllowMovement] = React.useState(true);

    const handleCadPositionLock = () => {
        // Toggle the lock state
        setAllowMovement(!allowMovement);
        allowCadMovePosition$.next(allowMovement);
    };

    return (
        <CadPositionLockButtonContainer>
            <CustomSwitchComponent label="Lock CAD Position" onChange={handleCadPositionLock} checked={!allowMovement} testId="cad-position-lock-switch" />
        </CadPositionLockButtonContainer>
    );
}

const CadPositionLockButtonContainer = styled.div`
    min-height: 50px;
    margin-top: 20px;
`;
